import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn } from '@/utils/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // ==================== 主 Tab 页 ====================
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/homepage/Home.vue'),
      meta: { title: '首页', requireAuth: true },
    },
    {
      path: '/academic',
      name: 'Academic',
      component: () => import('@/views/academic/Academic.vue'),
      meta: { title: '教务成绩', requireAuth: true },
    },
    {
      path: '/campus',
      name: 'CampusLife',
      component: () => import('@/views/campus/CampusLife.vue'),
      meta: { title: '校园生活', requireAuth: true },
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: { title: '个人中心' },
    },

    // ==================== 子页面 ====================
    {
      path: '/schedule',
      name: 'Schedule',
      component: () => import('@/views/academic/Schedule.vue'),
      meta: { title: '课程表', requireAuth: true },
    },
    {
      path: '/payment',
      name: 'Payment',
      component: () => import('@/views/profile/Payment.vue'),
      meta: { title: '缴费中心', requireAuth: true },
    },
    {
      path: '/leave-records',
      name: 'LeaveRecords',
      component: () => import('@/views/academic/LeaveRecords.vue'),
      meta: { title: '请假记录', requireAuth: true },
    },
    {
      path: '/out-in-school',
      name: 'OutInSchool',
      component: () => import('@/views/homepage/OutInSchool.vue'),
      meta: { title: '出入校记录', requireAuth: true },
    },
    {
      path: '/out-in-school-detail',
      name: 'OutInSchoolDetail',
      component: () => import('@/views/homepage/OutInSchoolDetail.vue'),
      meta: { title: '出入校详情', requireAuth: true },
    },
    {
      path: '/dormitory-attendance',
      name: 'DormitoryAttendance',
      component: () => import('@/views/homepage/DormitoryAttendance.vue'),
      meta: { title: '寝室考勤记录', requireAuth: true },
    },
    {
      path: '/student-check-in',
      name: 'StudentCheckIn',
      component: () => import('@/views/homepage/StudentCheckIn.vue'),
      meta: { title: '学生打卡', requireAuth: true },
    },
    {
      path: '/subscribe',
      name: 'Subscribe',
      component: () => import('@/views/Subscribe.vue'),
      meta: { title: '进出校提醒', requireAuth: true },
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { title: '登录', requireAuth: false },
    },
  ],
})

// 全局路由守卫 —— 未登录则跳转到登录页
router.beforeEach((to, _from, next) => {
  // 登录页无需鉴权
  if (to.meta.requireAuth === false) {
    next()
    return
  }

  // 如果页面明确要求登录，且当前未登录，则跳转登录页
  if (to.meta.requireAuth === true && !isLoggedIn.value) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

// 页面标题守卫
router.afterEach((to) => {
  const title = to.meta.title as string
  if (title) {
    document.title = `${title} - ${import.meta.env.VITE_APP_TITLE}`
  }
})

export default router
